<template>
  <div>
    <b-row>
      <b-col cols="12">
        <div v-if="errors.length" class="alert alert-danger">
          <ul>
            <li v-for="error in errors" :key="error.msg">
              {{ error.msg }}
            </li>
          </ul>
        </div>

        <h2>
          Phone Number
        </h2>
        <b-form>
          <b-form-row>
            <b-col>
              <b-form-group
                horizontal
                :label-cols="4"
                breakpoint="md"
                label="Enter Phone Number"
              >
                <b-form-input v-model="phone"></b-form-input
              ></b-form-group>
            </b-col>
          </b-form-row>
          <b-button @click="findCallThere">Search</b-button>
        </b-form>
        <br />
        <br />

        <b-form @submit.prevent="showPopup">
          <b-form-row>
            <b-col>
              <b-form-group
                horizontal
                :label-cols="4"
                breakpoint="md"
                label="Enter Latitude"
              >
                <b-form-input v-model="latitude"></b-form-input
              ></b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                horizontal
                :label-cols="4"
                breakpoint="md"
                label="Enter Longitude"
              >
                <b-form-input v-model="longitude"></b-form-input
              ></b-form-group>
            </b-col>
          </b-form-row>

          <b-form-group
            horizontal
            :label-cols="4"
            breakpoint="md"
            label="Enter Radius"
          >
            <b-form-input v-model="radius"></b-form-input>
          </b-form-group>
          <b-form-row>
            <b-col>
              <b-form-group
                horizontal
                :label-cols="4"
                breakpoint="md"
                label="Start Date"
              >
                <datetime v-model="startDate" type="datetime"></datetime>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                horizontal
                :label-cols="4"
                breakpoint="md"
                label="End Date"
              >
                <datetime v-model="endDate" type="datetime"></datetime>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-button @click="preview">Search</b-button>
          <b-form-row>
            <div v-if="stat.count">
              <div>Total: {{ stat.count }}</div>
              <br />
              <div>
                Male: {{ stat.male }} ({{ stat.maleAgeFrom }}-{{
                  stat.maleAgeTo
                }})
              </div>
              <br />
              <div>
                Female: {{ stat.female }} ({{ stat.femaleAgeFrom }}-{{
                  stat.femaleAgeTo
                }})
              </div>
              <br />
            </div>
          </b-form-row>

          <h2>
            Send Notification
          </h2>

          <b-form-group
            horizontal
            :label-cols="4"
            breakpoint="md"
            label="Notification Title"
          >
            <b-form-input v-model="title"></b-form-input>
          </b-form-group>
          <b-form-group
            horizontal
            :label-cols="4"
            breakpoint="md"
            label="Notification Text"
          >
            <b-form-textarea
              v-model="text"
              placeholder="Notification Text"
              :rows="10"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            horizontal
            :label-cols="4"
            breakpoint="md"
            label="Advertiser"
          >
            <b-form-input v-model="advertiser"></b-form-input>
          </b-form-group>

          <b-form-row>
            <b-col
              ><b-form-checkbox v-model="male">Male</b-form-checkbox></b-col
            >
            <b-col
              ><b-form-input v-if="male" v-model="maleStartAge"></b-form-input
            ></b-col>
            <b-col
              ><b-form-input v-if="male" v-model="maleEndAge"></b-form-input
            ></b-col>
            <b-col
              ><b-form-input v-if="male" v-model="maleCount"></b-form-input
            ></b-col>
          </b-form-row>
          <b-form-row>
            <b-col
              ><b-form-checkbox v-model="female">Female</b-form-checkbox></b-col
            >
            <b-col
              ><b-form-input
                v-if="female"
                v-model="femaleStartAge"
              ></b-form-input
            ></b-col>
            <b-col
              ><b-form-input v-if="female" v-model="femaleEndAge"></b-form-input
            ></b-col>
            <b-col
              ><b-form-input v-if="female" v-model="femaleCount"></b-form-input
            ></b-col>
          </b-form-row>
          <b-form-group
            horizontal
            :label-cols="4"
            breakpoint="md"
            label="Duration"
          >
            <b-form-input v-model="duration"></b-form-input>
          </b-form-group>
          <b-form-group
            horizontal
            :label-cols="4"
            breakpoint="md"
            label="Categories"
          >
            <b-form-input v-model="categories"></b-form-input>
          </b-form-group>

          <tr>
            <th>Deal Address</th>
            <td>
              <b-form-input
                v-model.trim="newAddress"
                @blur.native="geocode"
                @change="changed = true"
              ></b-form-input>
            </td>
          </tr>
          <tr>
            <th>Deal Latitude</th>
            <td>
              <b-form-input v-model.trim="newDealLatitude"></b-form-input>
            </td>
          </tr>
          <tr>
            <th>Deal Longitude</th>
            <td>
              <b-form-input v-model.trim="newDealLongitude"></b-form-input>
            </td>
          </tr>

          <b-button type="submit" variant="primary">Send</b-button>
        </b-form>
      </b-col>
    </b-row>
    <b-modal ref="confirmModal" @ok="onSubmit">
      <b-form @submit.prevent="onSubmit">
        Are you sure you want to send the notification?
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import API from '@/api';
import { DateTime as LuxonDateTime } from 'luxon';
import Geocoder from '@/geocoder';

export default {
  name: 'TheNotificationDetail',
  data() {
    return {
      male: true,
      maleStartAge: 1,
      maleEndAge: 100,
      female: true,
      femaleStartAge: 1,
      femaleEndAge: 100,
      longitude: 0,
      advertiser: '',
      latitude: 0,
      radius: 1000,
      errors: [],
      startDate: LuxonDateTime.local()
        .minus({ days: 1 })
        .toISO(),
      endDate: LuxonDateTime.local()
        .plus({ days: 1 })
        .toISO(),
      title: '',
      text: '',
      stat: {},
      config: {
        format: 'DD/MM/YYYY',
        useCurrent: false
      },
      configTime: {
        format: 'LT',
        useCurrent: false
      },
      maleCount: 0,
      femaleCount: 0,
      phone: '',
      duration: '',
      categories: '',
      newAddress: '',
      newDealLatitude: 0,
      newDealLongitude: 0
    };
  },
  created() {
    // this.reloadList()
  },
  methods: {
    onSubmit() {
      API.post(`notification/send`, {
        longitude: this.longitude,
        latitude: this.latitude,
        male: this.male,
        maleStartAge: this.maleStartAge ? this.maleStartAge : 0,
        maleEndAge: this.maleEndAge ? this.maleEndAge : 0,
        female: this.female,
        femaleStartAge: this.femaleStartAge ? this.femaleStartAge : 0,
        femaleEndAge: this.femaleEndAge ? this.femaleEndAge : 0,
        radius: this.radius,
        startDate: '' + new Date(this.startDate).getTime(),
        startDateText: this.startDate /**/,
        endDate: '' + new Date(this.endDate).getTime(),
        endDateText: this.endDate,
        title: this.title,
        text: this.text,
        maleCount: this.maleCount,
        femaleCount: this.femaleCount,
        advertiser: this.advertiser,
        duration: this.duration,
        categories: this.categories,
        dealAddress: this.newAddress,
        dealLatitude: this.newDealLatitude,
        dealLongitude: this.newDealLongitude
      }).then(res => {
        if (res.status === 'ok') {
          alert('Notifications sent: ' + res.data.count);
          this.errors = [];
        } else {
          this.errors = res.errors;
        }
      });
    },
    preview() {
      API.post(`user/search`, {
        longitude: this.longitude,
        latitude: this.latitude,
        radius: this.radius,
        startDate: '' + new Date(this.startDate).getTime(),
        endDate: '' + new Date(this.endDate).getTime()
      }).then(res => {
        if (res.status === 'ok') {
          this.stat = res.data;
          this.maleStartAge = this.stat.maleAgeFrom;
          this.maleEndAge = this.stat.maleAgeTo;
          this.maleCount = this.stat.male;
          this.femaleStartAge = this.stat.femaleAgeFrom;
          this.femaleEndAge = this.stat.femaleAgeTo;
          this.femaleCount = this.stat.female;
          this.errors = [];
        } else {
          this.stat = {};
          this.errors = res.errors;
        }
      });
    },
    showPopup() {
      this.$refs.confirmModal.show();
    },
    findCallThere() {
      API.post(`callthere/load_phone_info`, {
        phone: this.phone
      }).then(res => {
        if (res.status === 'ok') {
          if (res.data) {
            this.longitude = res.data.lng;
            this.latitude = res.data.lat;
            this.radius = res.data.radius;
            this.errors = [];
          } else {
            alert('Phone not found');
          }
        } else {
          this.errors = res.errors;
        }
      });
    },
    geocode() {
      let $this = this;
      if (this.newAddress.length) {
        Geocoder.request(this.newAddress).then(res => {
          if (res.data) {
            res = res.data.result;
            $this.changed = false;
            this.newDealLongitude = res.geometry.location
              ? res.geometry.location.lng
              : '';
            this.newDealLatitude = res.geometry.location
              ? res.geometry.location.lat
              : '';
          }
        });
      }
    }
  }
};
</script>
